// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* div {
  border: 1px solid black;
} */

.address_container__-t1K2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
}

.address_mapContainer__6fizf {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  height: 600px;
}

.address_descContainer__6g0w9 {
  display: flex;
  width : 90%;
  justify-content: space-between;
}

.address_desc__9h80H {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.address_descSchedule__oSx9K {
  display: flex;
  align-items: center;
  line-height: 13px;
}

.address_text-top-1__DZDDU {
  text-align: center;
  letter-spacing: 5px;
  font-size: 16px;
  color: black;
}

.address_text-top-2__LcaRA {
  text-align: center;
  margin: 0;
  font-size: 45px;
  color: black
}


.address_text-desc-1__yi0wE {
  color: #0c78b7;
}

.address_text-intense-1__ZXdE3 {
  font-size: 20px;
  font-weight: 700;
}

.address_blog-box__0B-9y {
  display : flex;
  justify-content: flex-start;
  align-items: center;
}

.address_phonelink__S-FwS {
  text-decoration: none; /* 밑줄 제거 */
  color: inherit; /* 부모 요소의 색상을 상속받음 */
}

.address_phonetext__0AlaF {
  display: inline-block;
  background-color: #0c78b7;
  color: white;
  width : auto;
}





@media (max-width: 1247px) {
  .address_descContainer__6g0w9 {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 15px;
    padding-bottom: 23px;
    
  }

  .address_text-top-1__DZDDU {
    text-align: center;
    letter-spacing: 3px;
    font-size: 12px;
  }
  
  .address_text-top-2__LcaRA {
    text-align: center;
    font-size: 25px;
  }

  .address_mapContainer__6fizf {
    height: 400px;
  }
  .address_text-desc-1__yi0wE {
    line-height: 0;
  }

  
  .address_text-intense-1__ZXdE3 {
    margin: 10px 0;
  }

  .address_phonetext__0AlaF {
    padding : 10px;
    margin: 0px 0;
  }
}

@media (min-width: 1248px) and (max-width: 1900px) {
  .address_mapContainer__6fizf {
    width: 60%;
  }
  
  .address_descContainer__6g0w9 {
    width : 60%;
  }

  .address_mapContainer__6fizf {
    height: 600px;
  }
  .address_top__flFgt {
    padding : 1%
  }

  .address_text-desc-1__yi0wE {
    
    font-size: 24px;
  }

  .address_descSchedule__oSx9K {
    font-size: 16px;
  }
  .address_text-intense-1__ZXdE3 {
    font-size: 26px;
    line-height: 20px;
  }
  .address_telbox__16leQ {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 20px;
    line-height: 20px;
  }
  .address_telbox__16leQ p {
    margin : 8px 0;
  }
  .address_phonetext__0AlaF {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (min-width: 1901px) {
  .address_mapContainer__6fizf {
    width: 60%;
  }
  
  .address_descContainer__6g0w9 {
    width : 60%;
  }

  .address_mapContainer__6fizf {
    height: 600px;
  }
  .address_top__flFgt {
    padding : 1%
  }

  .address_text-desc-1__yi0wE {
    font-size: 30px;
  }

  .address_descSchedule__oSx9K {
    font-size: 24px;
    line-height: 25px;
  }
  .address_text-intense-1__ZXdE3 {
    font-size: 26px;
  }
  .address_telbox__16leQ {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 20px;
    line-height: 25px;
  }
  .address_telbox__16leQ p {
    margin : 8px 0;
  }

  .address_phonetext__0AlaF {
    padding-left: 10px;
    padding-right: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/address.module.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf;AACF;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB,EAAE,UAAU;EACjC,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;;;;;AAMA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;;EAEtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;;EAGA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;EACA;IACE;EACF;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;EACA;IACE;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["/* div {\n  border: 1px solid black;\n} */\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  \n}\n\n.mapContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 90%;\n  height: 600px;\n}\n\n.descContainer {\n  display: flex;\n  width : 90%;\n  justify-content: space-between;\n}\n\n.desc {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.descSchedule {\n  display: flex;\n  align-items: center;\n  line-height: 13px;\n}\n\n.text-top-1 {\n  text-align: center;\n  letter-spacing: 5px;\n  font-size: 16px;\n  color: black;\n}\n\n.text-top-2 {\n  text-align: center;\n  margin: 0;\n  font-size: 45px;\n  color: black\n}\n\n\n.text-desc-1 {\n  color: #0c78b7;\n}\n\n.text-intense-1 {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.blog-box {\n  display : flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.phonelink {\n  text-decoration: none; /* 밑줄 제거 */\n  color: inherit; /* 부모 요소의 색상을 상속받음 */\n}\n\n.phonetext {\n  display: inline-block;\n  background-color: #0c78b7;\n  color: white;\n  width : auto;\n}\n\n\n\n\n\n@media (max-width: 1247px) {\n  .descContainer {\n    flex-direction: column;\n    align-items: flex-start;\n    padding-top: 15px;\n    padding-bottom: 23px;\n    \n  }\n\n  .text-top-1 {\n    text-align: center;\n    letter-spacing: 3px;\n    font-size: 12px;\n  }\n  \n  .text-top-2 {\n    text-align: center;\n    font-size: 25px;\n  }\n\n  .mapContainer {\n    height: 400px;\n  }\n  .text-desc-1 {\n    line-height: 0;\n  }\n\n  \n  .text-intense-1 {\n    margin: 10px 0;\n  }\n\n  .phonetext {\n    padding : 10px;\n    margin: 0px 0;\n  }\n}\n\n@media (min-width: 1248px) and (max-width: 1900px) {\n  .mapContainer {\n    width: 60%;\n  }\n  \n  .descContainer {\n    width : 60%;\n  }\n\n  .mapContainer {\n    height: 600px;\n  }\n  .top {\n    padding : 1%\n  }\n\n  .text-desc-1 {\n    \n    font-size: 24px;\n  }\n\n  .descSchedule {\n    font-size: 16px;\n  }\n  .text-intense-1 {\n    font-size: 26px;\n    line-height: 20px;\n  }\n  .telbox {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-bottom: 20px;\n    line-height: 20px;\n  }\n  .telbox p {\n    margin : 8px 0;\n  }\n  .phonetext {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}\n\n@media (min-width: 1901px) {\n  .mapContainer {\n    width: 60%;\n  }\n  \n  .descContainer {\n    width : 60%;\n  }\n\n  .mapContainer {\n    height: 600px;\n  }\n  .top {\n    padding : 1%\n  }\n\n  .text-desc-1 {\n    font-size: 30px;\n  }\n\n  .descSchedule {\n    font-size: 24px;\n    line-height: 25px;\n  }\n  .text-intense-1 {\n    font-size: 26px;\n  }\n  .telbox {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-bottom: 20px;\n    line-height: 25px;\n  }\n  .telbox p {\n    margin : 8px 0;\n  }\n\n  .phonetext {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `address_container__-t1K2`,
	"mapContainer": `address_mapContainer__6fizf`,
	"descContainer": `address_descContainer__6g0w9`,
	"desc": `address_desc__9h80H`,
	"descSchedule": `address_descSchedule__oSx9K`,
	"text-top-1": `address_text-top-1__DZDDU`,
	"text-top-2": `address_text-top-2__LcaRA`,
	"text-desc-1": `address_text-desc-1__yi0wE`,
	"text-intense-1": `address_text-intense-1__ZXdE3`,
	"blog-box": `address_blog-box__0B-9y`,
	"phonelink": `address_phonelink__S-FwS`,
	"phonetext": `address_phonetext__0AlaF`,
	"top": `address_top__flFgt`,
	"telbox": `address_telbox__16leQ`
};
export default ___CSS_LOADER_EXPORT___;
